import { useNavigate } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiAlertTriangle } from 'react-icons/fi';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon">
          <FiAlertTriangle />
        </div>

        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">Page not found</h2>
        <p className="not-found-message">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div className="not-found-actions">
          <button className="not-found-back-btn" onClick={() => navigate(-1)}>
            <FiArrowLeft />
            Go back
          </button>
          <button className="not-found-home-btn" onClick={() => navigate('/')}>
            <FiHome />
            Go home
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
